// Print just one element (a receipt, the QR sheet) instead of the whole page.
//
// A copy of the element is placed in #print-root and <body> gets data-print;
// the @media print rules in responsive.css then remove everything else from
// the page for that print. Removing (display:none) rather than merely hiding
// matters: hidden content still takes up space, which would add blank pages
// and repeat fixed-position popups on every one of them.
//
// The copy and marks are removed as soon as printing is done — and, as a
// safety net so the screen can never stay blank, on the next tap/keypress or
// after 30 seconds.
export function printElement(el, kind = "receipt") {
  if (!el) {
    window.print();
    return;
  }

  let root = document.getElementById("print-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "print-root";
    document.body.appendChild(root);
  }
  root.textContent = "";
  const copy = el.cloneNode(true);
  copy.classList.add("print-target");
  copy.removeAttribute("id");
  root.appendChild(copy);
  document.body.setAttribute("data-print", kind);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    document.body.removeAttribute("data-print");
    root.textContent = "";
    window.removeEventListener("afterprint", cleanup);
    window.removeEventListener("pointerdown", cleanup, true);
    window.removeEventListener("keydown", cleanup, true);
    clearTimeout(timer);
  };
  const timer = setTimeout(cleanup, 30000);
  window.addEventListener("afterprint", cleanup);
  window.addEventListener("pointerdown", cleanup, true);
  window.addEventListener("keydown", cleanup, true);

  window.print();
}
